import { render, staticRenderFns } from "./PAPCreditVsDebitSummary.vue?vue&type=template&id=5b0af41a&scoped=true&"
import script from "./PAPCreditVsDebitSummary.vue?vue&type=script&lang=js&"
export * from "./PAPCreditVsDebitSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0af41a",
  null
  
)

export default component.exports